import { CONDITION_ACTION, CONDITION_DECISION, CONDITION_SOURCE, SOURCE_OPTIONS } from "@builder/utils/constants";

export const sourceOptions = [
    SOURCE_OPTIONS.USER,
    SOURCE_OPTIONS.ROLE,
    SOURCE_OPTIONS.PRODUCT_IN_CART,
    SOURCE_OPTIONS.CART_VALUE,
    SOURCE_OPTIONS.NUMBER_OF_PRODUCT_IN_CART,
    SOURCE_OPTIONS.ACTIVE_PRODUCT,
    SOURCE_OPTIONS.ACTIVE_CUSTOMER,
    SOURCE_OPTIONS.CUSTOMER_IN_CART,
    SOURCE_OPTIONS.ACTIVE_ORDER,
    SOURCE_OPTIONS.IDLE_TIME,
    SOURCE_OPTIONS.NEW_ORDER
];

export const actionSelectOptions = [CONDITION_ACTION.HIDE, CONDITION_ACTION.SHOW, CONDITION_ACTION.DISABLE];

export const conditionOptions = [
    CONDITION_DECISION.IS,
    CONDITION_DECISION.IS_NOT,
    CONDITION_DECISION.MORE_THAN,
    CONDITION_DECISION.LESS_THAN,
    CONDITION_DECISION.CONTAINS_ANY_OF,
    CONDITION_DECISION.DOES_NOT_CONTAIN_ANY_OF,
    CONDITION_DECISION.CONTAINS_ALL_OF,
    CONDITION_DECISION.DOES_NOT_CONTAIN_ALL_OF
];

export const getConditionOptions = (source: string) => {
    if (source.toLowerCase().includes("time")) {
        return [CONDITION_DECISION.MORE_THAN];
    }

    if (source.toLowerCase().includes("new")) {
        return [CONDITION_DECISION.IS];
    }

    if (
        source.toLowerCase().includes(CONDITION_SOURCE.USER) ||
        source.toLowerCase().includes(CONDITION_SOURCE.ROLE) ||
        source.toLowerCase().includes(CONDITION_SOURCE.PRODUCT_IN_CART) ||
        source.toLowerCase().includes(CONDITION_SOURCE.CUSTOMER_IN_CART) ||
        source.toLowerCase().includes("active")
    ) {
        return conditionOptions.filter(condition => !condition.includes("than"));
    }

    if (source.toLowerCase().includes("value") || source.toLowerCase().includes("#")) {
        return conditionOptions.filter(condition => !condition.includes("of"));
    }

    return source ? conditionOptions : [];
};
